import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ShowInEpcotDirective } from '../../../lib/common/epcot-config.directive';
import { AlertContentComponent } from './components/alert-content.component';
import { AlertComponent } from './components/alert.component';

@NgModule({
    imports: [CommonModule, ShowInEpcotDirective],
    declarations: [AlertContentComponent, AlertComponent],
    exports: [AlertComponent],
    providers: [],
})
export default class BetslipAlertsModule {}
